"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Figure = Figure;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _helpers = require("../../../utils/helpers");
var _FigureSlideModule = _interopRequireDefault(require("./../../../scss/slide-layouts/FigureSlide.module.scss"));
function Figure(_ref) {
  let {
    images = [{
      url: '',
      altText: '',
      caption: ''
    }],
    imagesPerSlide = 1
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _FigureSlideModule.default['figure-slide']
  }, images.map((image, index) => {
    return /*#__PURE__*/_react.default.createElement("figure", {
      className: (0, _helpers.classes)([_FigureSlideModule.default['figure-slide__figure'], image !== null && image !== void 0 && image.caption ? _FigureSlideModule.default['figure-slide--captioned-image'] : '']),
      style: {
        backgroundImage: "url(".concat(image.url, ")"),
        flexBasis: "".concat(100 / imagesPerSlide, "%")
      },
      key: "figure-".concat(index),
      title: image.altText !== '' ? image.altText : ''
    }, (image === null || image === void 0 ? void 0 : image.caption) && /*#__PURE__*/_react.default.createElement("figcaption", null, image.caption));
  }));
}
var _default = exports.default = Figure;